import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';

import { accountShape, bibShape, branchShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';
import Checkbox from '@bibliocommons/base-checkbox';
import { ModalHeader, ModalContent, ModalFooter } from '@bibliocommons/modal';
import HoldInfoMessages from 'app/components/shared/HoldInfoMessages';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import PickupBranchSelect from 'app/components/bibs/shared/PickupBranchSelect';
import { MATERIAL_TYPE_PHYSICAL } from 'app/constants/BibConstants';

import './PhysicalHoldForm.scss';

export default class PhysicalHoldForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedBranchCode: props.preferredBranches.first() ? props.preferredBranches.first().get('code') : '',
      enableSingleClickHolds: false
    };

    bindAll(this);
  }

  handleBranchChange(selectedBranchCode) {
    this.setState({ selectedBranchCode });
  }

  handleSingleClickHoldsChange(enableSingleClickHolds) {
    this.setState({ enableSingleClickHolds });
  }

  handlePlaceHold() {
    const { bib, currentAccount, reciprocalRank, handleClose, holdActions } = this.props;
    const { enableSingleClickHolds, selectedBranchCode } = this.state;

    holdActions.placeHold({
      postSuccess: handleClose,
      materialType: MATERIAL_TYPE_PHYSICAL,
      accountId: currentAccount.get('id'),
      metadataId: bib.get('id'),
      enableSingleClickHolds,
      reciprocalRank,
      materialParams: {
        branchId: selectedBranchCode,
        expiryDate: null
      }
    });
  }

  renderBranchSelect() {
    const { currentAccount, branches, preferredBranches } = this.props;

    return (
      <PickupBranchSelect
        branches={branches}
        preferredBranches={preferredBranches}
        currentAccount={currentAccount}
        selectedBranchCode={this.state.selectedBranchCode}
        handleChange={this.handleBranchChange}
      />
    );
  }

  renderSingleClickHoldsCheckbox() {
    return (
      <div>
        <Checkbox
          id="single-click-holds-checkbox"
          dataKey="single-click-holds-checkbox"
          aria-describedby="single-click-description"
          label={<FormattedMessage id="place_hold_single_click_label" />}
          checked={this.state.enableSingleClickHolds}
          handleChange={this.handleSingleClickHoldsChange}
        />
        <div className="single-click-description" id="single-click-description">
          <FormattedMessage id="place_hold_single_click_description" />
        </div>
      </div>
    );
  }

  render() {
    const { bib, currentLibrary, holdsTransactions } = this.props;
    const isPlacingHold = holdsTransactions.getIn([bib.get('id'), 'isPlacingHold'], false);
    const holdInfoMessages = currentLibrary.get('holdInfoMessages', Immutable.List());

    return (
      <div className="cp-physical-hold-form">
        <ModalHeader title={<FormattedMessage id="place_hold" />} />
        <ModalContent>
          <BibBriefContainer metadataId={bib.get('id')} />
          <HoldInfoMessages messageIds={holdInfoMessages} />
          {this.renderBranchSelect()}
          {this.renderSingleClickHoldsCheckbox()}
        </ModalContent>
        <ModalFooter
          primaryActionButtonTag={TransactionalSolidButton}
          primaryActionButtonText={<FormattedMessage id="place_hold" />}
          handlePrimaryAction={this.handlePlaceHold}
          disabled={!this.state.selectedBranchCode}
          isLoading={isPlacingHold}
        />
      </div>
    );
  }
}

PhysicalHoldForm.propTypes = {
  bib: bibShape.isRequired,
  currentAccount: accountShape.isRequired,
  currentLibrary: libraryShape.isRequired,
  handleClose: PropTypes.func.isRequired,
  reciprocalRank: PropTypes.number,
  branches: ImmutablePropTypes.listOf(branchShape).isRequired,
  preferredBranches: ImmutablePropTypes.listOf(branchShape).isRequired,
  holdsTransactions: ImmutablePropTypes.map.isRequired,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired
};
